module.exports = __webpack_public_path__ + "static/media/ihr.52ad710e.jpg";